export default [

    {
        name: '1',
        qty: 1
    },
    {
        name: '2',
        qty: 2
    },
    {
        name: '3',
        qty: 3
    },
    {
        name: '4',
        qty: 4
    },
    {
        name: '5',
        qty: 5
    },
    {
        name: '6',
        qty: 6
    },

  ];